import {
  CLEAR_VCARD,
  GET_VCARD_END,
  GET_VCARD_START,
  SET_VCARD,
} from "../actions/Vcard/types";
const initialState = {
  vCard: {},
  haveSubscription: false,
  status: null,
  message: null,
  loading: false,
};

const vCardReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case GET_VCARD_START:
      return { ...state, loading: true };

    case SET_VCARD:
      return {
        ...state,
        haveSubscription: payload.haveSubscription,
        status: payload?.status,
        vCard: payload?.data,
        message: payload.message,
      };

    case GET_VCARD_END:
      return { ...state, loading: false };
    case CLEAR_VCARD:
      return {
        ...state,
        haveSubscription: false,
        staus: null,
        message: null,
        vCard: {},
      };

    default:
      return state;
  }
};

export default vCardReducer;
